import { render, staticRenderFns } from "./TeacherContactForm.vue?vue&type=template&id=3503965d&scoped=true"
import script from "./TeacherContactForm.vue?vue&type=script&lang=js"
export * from "./TeacherContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503965d",
  null
  
)

export default component.exports